import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as nls from '../../../nls.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { IEditorProgressService } from '../../../platform/progress/common/progress.js';
import { registerEditorAction, registerEditorContribution, EditorAction, EditorCommand, registerEditorCommand, registerModelAndPositionCommand } from '../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { RenameInputField, CONTEXT_RENAME_INPUT_VISIBLE } from './renameInputField.js';
import { RenameProviderRegistry } from '../../common/modes.js';
import { Position } from '../../common/core/position.js';
import { alert } from '../../../base/browser/ui/aria/aria.js';
import { Range } from '../../common/core/range.js';
import { MessageController } from '../message/messageController.js';
import { EditorStateCancellationTokenSource } from '../../browser/core/editorState.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IBulkEditService, ResourceEdit } from '../../browser/services/bulkEditService.js';
import { URI } from '../../../base/common/uri.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { CancellationToken, CancellationTokenSource } from '../../../base/common/cancellation.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { IdleValue, raceCancellation } from '../../../base/common/async.js';
import { ILogService } from '../../../platform/log/common/log.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { Registry } from '../../../platform/registry/common/platform.js';
import { Extensions } from '../../../platform/configuration/common/configurationRegistry.js';
import { ITextResourceConfigurationService } from '../../common/services/textResourceConfigurationService.js';
import { assertType } from '../../../base/common/types.js';

var RenameSkeleton = /*#__PURE__*/function () {
  function RenameSkeleton(model, position) {
    _classCallCheck(this, RenameSkeleton);

    this.model = model;
    this.position = position;
    this._providerRenameIdx = 0;
    this._providers = RenameProviderRegistry.ordered(model);
  }

  _createClass(RenameSkeleton, [{
    key: "hasProvider",
    value: function hasProvider() {
      return this._providers.length > 0;
    }
  }, {
    key: "resolveRenameLocation",
    value: function resolveRenameLocation(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var rejects, provider, res, word;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rejects = [];
                this._providerRenameIdx = 0;

              case 2:
                if (!(this._providerRenameIdx < this._providers.length)) {
                  _context.next = 18;
                  break;
                }

                provider = this._providers[this._providerRenameIdx];

                if (provider.resolveRenameLocation) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("break", 18);

              case 6:
                _context.next = 8;
                return provider.resolveRenameLocation(this.model, this.position, token);

              case 8:
                res = _context.sent;

                if (res) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("continue", 15);

              case 11:
                if (!res.rejectReason) {
                  _context.next = 14;
                  break;
                }

                rejects.push(res.rejectReason);
                return _context.abrupt("continue", 15);

              case 14:
                return _context.abrupt("return", res);

              case 15:
                this._providerRenameIdx++;
                _context.next = 2;
                break;

              case 18:
                word = this.model.getWordAtPosition(this.position);

                if (word) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", {
                  range: Range.fromPositions(this.position),
                  text: '',
                  rejectReason: rejects.length > 0 ? rejects.join('\n') : undefined
                });

              case 21:
                return _context.abrupt("return", {
                  range: new Range(this.position.lineNumber, word.startColumn, this.position.lineNumber, word.endColumn),
                  text: word.word,
                  rejectReason: rejects.length > 0 ? rejects.join('\n') : undefined
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "provideRenameEdits",
    value: function provideRenameEdits(newName, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._provideRenameEdits(newName, this._providerRenameIdx, [], token));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "_provideRenameEdits",
    value: function _provideRenameEdits(newName, i, rejects, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                provider = this._providers[i];

                if (provider) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", {
                  edits: [],
                  rejectReason: rejects.join('\n')
                });

              case 3:
                _context3.next = 5;
                return provider.provideRenameEdits(this.model, this.position, newName, token);

              case 5:
                result = _context3.sent;

                if (result) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", this._provideRenameEdits(newName, i + 1, rejects.concat(nls.localize('no result', "No result.")), token));

              case 10:
                if (!result.rejectReason) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", this._provideRenameEdits(newName, i + 1, rejects.concat(result.rejectReason), token));

              case 12:
                return _context3.abrupt("return", result);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return RenameSkeleton;
}();

export function rename(model, position, newName) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var skeleton, loc;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            skeleton = new RenameSkeleton(model, position);
            _context4.next = 3;
            return skeleton.resolveRenameLocation(CancellationToken.None);

          case 3:
            loc = _context4.sent;

            if (!(loc === null || loc === void 0 ? void 0 : loc.rejectReason)) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", {
              edits: [],
              rejectReason: loc.rejectReason
            });

          case 6:
            return _context4.abrupt("return", skeleton.provideRenameEdits(newName, CancellationToken.None));

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
} // ---  register actions and commands

var RenameController = /*#__PURE__*/function () {
  function RenameController(editor, _instaService, _notificationService, _bulkEditService, _progressService, _logService, _configService) {
    var _this = this;

    _classCallCheck(this, RenameController);

    this.editor = editor;
    this._instaService = _instaService;
    this._notificationService = _notificationService;
    this._bulkEditService = _bulkEditService;
    this._progressService = _progressService;
    this._logService = _logService;
    this._configService = _configService;
    this._dispoableStore = new DisposableStore();
    this._cts = new CancellationTokenSource();
    this._renameInputField = this._dispoableStore.add(new IdleValue(function () {
      return _this._dispoableStore.add(_this._instaService.createInstance(RenameInputField, _this.editor, ['acceptRenameInput', 'acceptRenameInputWithPreview']));
    }));
  }

  _createClass(RenameController, [{
    key: "dispose",
    value: function dispose() {
      this._dispoableStore.dispose();

      this._cts.dispose(true);
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var position, skeleton, loc, resolveLocationOperation, selection, selectionStart, selectionEnd, supportPreview, inputFieldResult, renameOperation;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._cts.dispose(true);

                if (this.editor.hasModel()) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", undefined);

              case 3:
                position = this.editor.getPosition();
                skeleton = new RenameSkeleton(this.editor.getModel(), position);

                if (skeleton.hasProvider()) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", undefined);

              case 7:
                this._cts = new EditorStateCancellationTokenSource(this.editor, 4
                /* Position */
                | 1
                /* Value */
                ); // resolve rename location

                _context6.prev = 8;
                resolveLocationOperation = skeleton.resolveRenameLocation(this._cts.token);

                this._progressService.showWhile(resolveLocationOperation, 250);

                _context6.next = 13;
                return resolveLocationOperation;

              case 13:
                loc = _context6.sent;
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](8);
                MessageController.get(this.editor).showMessage(_context6.t0 || nls.localize('resolveRenameLocationFailed', "An unknown error occurred while resolving rename location"), position);
                return _context6.abrupt("return", undefined);

              case 20:
                if (loc) {
                  _context6.next = 22;
                  break;
                }

                return _context6.abrupt("return", undefined);

              case 22:
                if (!loc.rejectReason) {
                  _context6.next = 25;
                  break;
                }

                MessageController.get(this.editor).showMessage(loc.rejectReason, position);
                return _context6.abrupt("return", undefined);

              case 25:
                if (!this._cts.token.isCancellationRequested) {
                  _context6.next = 27;
                  break;
                }

                return _context6.abrupt("return", undefined);

              case 27:
                this._cts.dispose();

                this._cts = new EditorStateCancellationTokenSource(this.editor, 4
                /* Position */
                | 1
                /* Value */
                , loc.range); // do rename at location

                selection = this.editor.getSelection();
                selectionStart = 0;
                selectionEnd = loc.text.length;

                if (!Range.isEmpty(selection) && !Range.spansMultipleLines(selection) && Range.containsRange(loc.range, selection)) {
                  selectionStart = Math.max(0, selection.startColumn - loc.range.startColumn);
                  selectionEnd = Math.min(loc.range.endColumn, selection.endColumn) - loc.range.startColumn;
                }

                supportPreview = this._bulkEditService.hasPreviewHandler() && this._configService.getValue(this.editor.getModel().uri, 'editor.rename.enablePreview');
                _context6.next = 36;
                return this._renameInputField.value.getInput(loc.range, loc.text, selectionStart, selectionEnd, supportPreview, this._cts.token);

              case 36:
                inputFieldResult = _context6.sent;

                if (!(typeof inputFieldResult === 'boolean')) {
                  _context6.next = 40;
                  break;
                }

                if (inputFieldResult) {
                  this.editor.focus();
                }

                return _context6.abrupt("return", undefined);

              case 40:
                this.editor.focus();
                renameOperation = raceCancellation(skeleton.provideRenameEdits(inputFieldResult.newName, this._cts.token), this._cts.token).then(function (renameResult) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var _this3 = this;

                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!(!renameResult || !this.editor.hasModel())) {
                              _context5.next = 2;
                              break;
                            }

                            return _context5.abrupt("return");

                          case 2:
                            if (!renameResult.rejectReason) {
                              _context5.next = 5;
                              break;
                            }

                            this._notificationService.info(renameResult.rejectReason);

                            return _context5.abrupt("return");

                          case 5:
                            this._bulkEditService.apply(ResourceEdit.convert(renameResult), {
                              editor: this.editor,
                              showPreview: inputFieldResult.wantsPreview,
                              label: nls.localize('label', "Renaming '{0}'", loc === null || loc === void 0 ? void 0 : loc.text),
                              quotableLabel: nls.localize('quotableLabel', "Renaming {0}", loc === null || loc === void 0 ? void 0 : loc.text)
                            }).then(function (result) {
                              if (result.ariaSummary) {
                                alert(nls.localize('aria', "Successfully renamed '{0}' to '{1}'. Summary: {2}", loc.text, inputFieldResult.newName, result.ariaSummary));
                              }
                            }).catch(function (err) {
                              _this3._notificationService.error(nls.localize('rename.failedApply', "Rename failed to apply edits"));

                              _this3._logService.error(err);
                            });

                          case 6:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this);
                  }));
                }, function (err) {
                  _this2._notificationService.error(nls.localize('rename.failed', "Rename failed to compute edits"));

                  _this2._logService.error(err);
                });

                this._progressService.showWhile(renameOperation, 250);

                return _context6.abrupt("return", renameOperation);

              case 44:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[8, 16]]);
      }));
    }
  }, {
    key: "acceptRenameInput",
    value: function acceptRenameInput(wantsPreview) {
      this._renameInputField.value.acceptInput(wantsPreview);
    }
  }, {
    key: "cancelRenameInput",
    value: function cancelRenameInput() {
      this._renameInputField.value.cancelInput(true);
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(RenameController.ID);
    }
  }]);

  return RenameController;
}();

RenameController.ID = 'editor.contrib.renameController';
RenameController = __decorate([__param(1, IInstantiationService), __param(2, INotificationService), __param(3, IBulkEditService), __param(4, IEditorProgressService), __param(5, ILogService), __param(6, ITextResourceConfigurationService)], RenameController); // ---- action implementation

export var RenameAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(RenameAction, _EditorAction);

  var _super = _createSuper(RenameAction);

  function RenameAction() {
    _classCallCheck(this, RenameAction);

    return _super.call(this, {
      id: 'editor.action.rename',
      label: nls.localize('rename.label', "Rename Symbol"),
      alias: 'Rename Symbol',
      precondition: ContextKeyExpr.and(EditorContextKeys.writable, EditorContextKeys.hasRenameProvider),
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 60
        /* F2 */
        ,
        weight: 100
        /* EditorContrib */

      },
      contextMenuOpts: {
        group: '1_modification',
        order: 1.1
      }
    });
  }

  _createClass(RenameAction, [{
    key: "runCommand",
    value: function runCommand(accessor, args) {
      var _this4 = this;

      var editorService = accessor.get(ICodeEditorService);

      var _ref = Array.isArray(args) && args || [undefined, undefined],
          _ref2 = _slicedToArray(_ref, 2),
          uri = _ref2[0],
          pos = _ref2[1];

      if (URI.isUri(uri) && Position.isIPosition(pos)) {
        return editorService.openCodeEditor({
          resource: uri
        }, editorService.getActiveCodeEditor()).then(function (editor) {
          if (!editor) {
            return;
          }

          editor.setPosition(pos);
          editor.invokeWithinContext(function (accessor) {
            _this4.reportTelemetry(accessor, editor);

            return _this4.run(accessor, editor);
          });
        }, onUnexpectedError);
      }

      return _get(_getPrototypeOf(RenameAction.prototype), "runCommand", this).call(this, accessor, args);
    }
  }, {
    key: "run",
    value: function run(accessor, editor) {
      var controller = RenameController.get(editor);

      if (controller) {
        return controller.run();
      }

      return Promise.resolve();
    }
  }]);

  return RenameAction;
}(EditorAction);
registerEditorContribution(RenameController.ID, RenameController);
registerEditorAction(RenameAction);
var RenameCommand = EditorCommand.bindToContribution(RenameController.get);
registerEditorCommand(new RenameCommand({
  id: 'acceptRenameInput',
  precondition: CONTEXT_RENAME_INPUT_VISIBLE,
  handler: function handler(x) {
    return x.acceptRenameInput(false);
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 99,
    kbExpr: EditorContextKeys.focus,
    primary: 3
    /* Enter */

  }
}));
registerEditorCommand(new RenameCommand({
  id: 'acceptRenameInputWithPreview',
  precondition: ContextKeyExpr.and(CONTEXT_RENAME_INPUT_VISIBLE, ContextKeyExpr.has('config.editor.rename.enablePreview')),
  handler: function handler(x) {
    return x.acceptRenameInput(true);
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 99,
    kbExpr: EditorContextKeys.focus,
    primary: 1024
    /* Shift */
    + 3
    /* Enter */

  }
}));
registerEditorCommand(new RenameCommand({
  id: 'cancelRenameInput',
  precondition: CONTEXT_RENAME_INPUT_VISIBLE,
  handler: function handler(x) {
    return x.cancelRenameInput();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 99,
    kbExpr: EditorContextKeys.focus,
    primary: 9
    /* Escape */
    ,
    secondary: [1024
    /* Shift */
    | 9
    /* Escape */
    ]
  }
})); // ---- api bridge command

registerModelAndPositionCommand('_executeDocumentRenameProvider', function (model, position) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var newName = args[0];
  assertType(typeof newName === 'string');
  return rename(model, position, newName);
}); //todo@joh use editor options world

Registry.as(Extensions.Configuration).registerConfiguration({
  id: 'editor',
  properties: {
    'editor.rename.enablePreview': {
      scope: 5
      /* LANGUAGE_OVERRIDABLE */
      ,
      description: nls.localize('enablePreview', "Enable/disable the ability to preview changes before renaming"),
      default: true,
      type: 'boolean'
    }
  }
});